import Layout from "@/components/feature/Layout";
import Hero from "./components/Hero";
import TrustStrip from "./components/TrustStrip";
import Services from "./components/Services";
import Work from "./components/Work";
import FinalCta from "./components/FinalCta";

export default function Home() {
  return (
    <Layout>
      <Hero />
      <TrustStrip />
      <Services />
      <Work />
      <FinalCta />
    </Layout>
  );
}